import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatDate } from '@/utils/date';
import { getInfoByCommunityId } from '@/api/main/admin'; // eslint-disable-next-line
// import animate from 'animate.css'

export default {
  data: function data() {
    return {
      todayDate: '',
      areaName: '文化宫管理平台',
      roleId: {},
      userName: '',
      checkIndex: 1,
      fullscreen: false,
      showDeviceType: -1,
      isSuper: 0,
      interval: null,
      creenClose: false
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
  },
  created: function created() {
    this.loadData();
    var that = this;
    this.interval = setInterval(function () {
      that.getNowFormatDate();
    }, 1000);
  },
  methods: {
    logout: function logout() {
      var _this = this;

      this.$confirm('您确定要退出, 是否继续?', '提示').then(function () {
        _this.$store.dispatch('LogOut').then(function () {
          location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
        });
      });
    },
    // 获取小区中心点坐标
    getMapCenterPoint: function getMapCenterPoint() {
      var _this2 = this;

      getInfoByCommunityId({}).then(function (res) {
        if (res.data.data !== null) {
          _this2.areaName = res.data.data.areaName + '管理平台';
        } else {
          _this2.areaName = '文化宫管理平台';
        }
      });
    },
    loadData: function loadData() {
      this.getMapCenterPoint();
      this.userName = this.$store.getters.name;
      this.isSuper = 1;
    },
    manage: function manage() {
      this.$router.push({
        name: 'dashboard'
      });
    },
    getNowFormatDate: function getNowFormatDate() {
      this.todayDate = formatDate(new Date(Date.now()), 'yyyy年MM月dd日 hh:mm:ss').toString();
    },
    closeDialog: function closeDialog() {
      this.checkIndex = 1;
    },
    back: function back() {
      this.checkIndex = 1;
    },
    mapHome: function mapHome() {
      this.checkIndex = 1;
      this.$refs.overview.showDeviceNew(-1); // var obj = {
      //   msgname: 'restore_layer'
      // }
      // window.frames['map'].postMessage(obj, '*')
    },
    realTimeAlarmClick: function realTimeAlarmClick() {
      this.checkIndex = 2;
      this.realTimeAlarmdialogVisible = true;
    },
    getFullCreeen: function getFullCreeen() {
      var element = document.documentElement;

      if (this.fullscreen) {
        this.creenClose = false;

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        this.creenClose = true;

        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }

      this.fullscreen = !this.fullscreen;
    }
  }
};